<div class="recent-goals">
    <div class="recent-goals-header">
        <h4 class="recent-goals-title text-center">
            {{ _i18n._9448_GOAL_REVIEW | translate }}
        </h4>
        <button
            class="recent-goals-sort"
            (click)="_onSortClick()"
        >
            <cmps-icon svgIcon="sort-variant"></cmps-icon>
            <span>{{ _i18n._9468_SORT | translate }}</span>
        </button>
    </div>
    <div class="scroll-panel">
        <cmps-accordion
            theme="c"
            [multi]="true"
        >
            <ng-container *ngFor="let c of state?.categories; let cc = index">
                <cmps-accordion-item
                    [isOpen]="c.isOpen"
                    (isOpenChange)="_onCategoryIsOpenChange($event, cc)"
                >
                    <cmps-accordion-header [useRightAngle]="true">
                        <span>{{ c.label | translate }}</span>
                    </cmps-accordion-header>
                    <cmps-accordion-content>
                        <ng-container
                            *ngIf="
                                (cc ===
                                    _GoalCategoryType.ACTIVE_FOR_THIS_COMMITMENT ||
                                    cc ===
                                        _GoalCategoryType.ACTIVE_FOR_OTHER_COMMITMENT) &&
                                c.items.length === 0
                            "
                        >
                            <span class="pl-2">
                                {{ _i18n._9741_NO_ACTIVE_GOALS | translate }}
                            </span>
                        </ng-container>
                        <ng-container *ngFor="let i of c.items">
                            <div
                                class="container-goal"
                                [class.active]="
                                    selectedGoalTrackingId ===
                                    i.goal.tracking_id
                                "
                                [attr.data-diffitemid]="i.goal.diffItemId"
                                (click)="_onReviewGoalClick($event, i)"
                            >
                                <div
                                    class="top-info"
                                    *ngIf="
                                        cc ===
                                        _GoalCategoryType.ACTIVE_FOR_OTHER_COMMITMENT
                                    "
                                >
                                    <div class="behaviour">
                                        <div
                                            [class.truncate]="
                                                !i.goal.subBehaviourName
                                            "
                                        >
                                            {{ _i18n._9525_B_ | translate }}
                                            {{ i.goal.behaviourName }}
                                        </div>
                                    </div>
                                    <div class="subbehaviour">
                                        <div *ngIf="i.goal.subBehaviourName">
                                            {{ _i18n._9526_S_B_ | translate }}
                                            {{ i.goal.subBehaviourName }}
                                        </div>
                                    </div>
                                </div>
                                <div class="goals-list-info">
                                    <div class="left-info">
                                        <div class="left-info-kpi">
                                            {{
                                                _i18n._9427_GOAL_METRIC
                                                    | translate
                                            }}: {{ i.goal.metricName }}
                                        </div>
                                        <div>
                                            {{ _i18n._721_GOAL | translate }}:
                                            <span
                                                *ngIf="i.goal.goalValue != null"
                                            >
                                                {{
                                                    i.goal.goalValue
                                                        | cmpsNumber: '1.0-2'
                                                }}
                                            </span>
                                            <span
                                                *ngIf="
                                                    cc ===
                                                        _GoalCategoryType.DRAFT &&
                                                    i.goal.goalValue == null
                                                "
                                            >
                                                !
                                            </span>
                                            &nbsp;&nbsp;
                                            <span
                                                class="left-info-bold"
                                                *ngIf="
                                                    i.goal
                                                        .improvementSinceLastGoal >=
                                                    0
                                                "
                                            >
                                                {{
                                                    i.goal
                                                        .improvementSinceLastGoal
                                                        | cmpsPercent: '1.0-2'
                                                }} </span
                                            >&nbsp;
                                            <cmps-icon
                                                class="cmps-cdk-fill-green-100"
                                                svgIcon="triangle"
                                                *ngIf="
                                                    i.goal
                                                        .improvementSinceLastGoal >
                                                    0
                                                "
                                            ></cmps-icon>
                                            <cmps-icon
                                                class="cmps-cdk-fill-red-100"
                                                svgIcon="triangle-down"
                                                *ngIf="
                                                    i.goal
                                                        .improvementSinceLastGoal <
                                                    0
                                                "
                                            ></cmps-icon>
                                        </div>
                                        <div>
                                            {{ _i18n._127_STATUS | translate }}:
                                            <ng-container
                                                *ngIf="
                                                    cc ===
                                                    _GoalCategoryType.DRAFT
                                                "
                                            >
                                                <ng-container
                                                    *ngIf="
                                                        i.goal.goalValue != null
                                                    "
                                                >
                                                    {{
                                                        i.statusLabel
                                                            | translate
                                                    }}
                                                </ng-container>
                                                <ng-container
                                                    *ngIf="
                                                        i.goal.goalValue == null
                                                    "
                                                >
                                                    <span
                                                        class="left-info-status-text"
                                                        (click)="
                                                            _onUpdateGoalClick(
                                                                $event,
                                                                i
                                                            )
                                                        "
                                                    >
                                                        {{
                                                            _i18n._9428_YOU_NEED_TO_SET_A_GOAL_HERE
                                                                | translate
                                                        }}
                                                    </span>
                                                </ng-container>
                                            </ng-container>
                                            <ng-container
                                                *ngIf="
                                                    cc !==
                                                    _GoalCategoryType.DRAFT
                                                "
                                            >
                                                <span
                                                    *ngIf="!i.achievementMissed"
                                                >
                                                    {{
                                                        i.statusLabel
                                                            | translate
                                                    }}
                                                </span>
                                                <span
                                                    [style.color]="
                                                        i.daysToAchievementColor
                                                    "
                                                    *ngIf="i.achievementMissed"
                                                >
                                                    {{
                                                        i.daysToAchievementLabel
                                                            | translate
                                                    }}
                                                </span>
                                            </ng-container>
                                        </div>
                                        <div>
                                            {{
                                                _i18n._9462_DATE_SET
                                                    | translate
                                            }}:
                                            <span
                                                *ngIf="
                                                    cc ===
                                                    _GoalCategoryType.DRAFT
                                                "
                                                >-</span
                                            >
                                            <span
                                                *ngIf="
                                                    cc !==
                                                    _GoalCategoryType.DRAFT
                                                "
                                            >
                                                {{
                                                    i.goal.dateSet
                                                        | cmpsDate
                                                            : 'LLL-dd-yyyy'
                                                }}
                                            </span>
                                        </div>
                                        <div>
                                            {{
                                                _i18n._9463_ACTIVE_GOAL_DAYS
                                                    | translate
                                            }}:
                                            <span
                                                *ngIf="
                                                    cc ===
                                                    _GoalCategoryType.DRAFT
                                                "
                                                >0</span
                                            >
                                            <span
                                                *ngIf="
                                                    cc !==
                                                    _GoalCategoryType.DRAFT
                                                "
                                            >
                                                {{ i.goal.activeGoalDays }}
                                            </span>
                                        </div>
                                    </div>
                                    <div class="middle-info">
                                        <div>
                                            {{ _i18n._726_TARGET | translate }}:
                                            <span>{{
                                                i.goal.target | number: '1.0-2'
                                            }}</span>
                                        </div>
                                        <div class="bold-text">
                                            {{ _i18n._725_ACTUAL | translate }}:
                                            <span
                                                class="middle-info-bold"
                                                *ngIf="
                                                    cc ===
                                                    _GoalCategoryType.DRAFT
                                                "
                                            >
                                                {{
                                                    i.goal.actual
                                                        | number: '1.0-2'
                                                }}
                                            </span>
                                            <ng-container
                                                *ngIf="
                                                    cc !==
                                                    _GoalCategoryType.DRAFT
                                                "
                                            >
                                                <span>{{
                                                    i.goal.actual
                                                        | cmpsNumber: '1.0-2'
                                                }}</span
                                                >&nbsp;&nbsp;&nbsp;&nbsp;<span
                                                    class="middle-info-bold"
                                                    *ngIf="
                                                        i.goal
                                                            .overallImprovement >=
                                                        0
                                                    "
                                                >
                                                    {{
                                                        i.goal
                                                            .overallImprovement
                                                            | cmpsPercent
                                                                : '1.0-2'
                                                    }}
                                                </span>
                                            </ng-container>
                                        </div>
                                        <div>
                                            {{
                                                _i18n._768___TO_TARGET
                                                    | translate
                                            }}:
                                            <span>{{
                                                i.goal.percentToTarget
                                                    | cmpsPercent: '1.0-2'
                                            }}</span>
                                        </div>
                                        <div>
                                            {{
                                                _i18n._767___TO_GOAL
                                                    | translate
                                            }}:
                                            <span
                                                *ngIf="
                                                    cc ===
                                                    _GoalCategoryType.DRAFT
                                                "
                                                >-</span
                                            >
                                            <span
                                                *ngIf="
                                                    cc !==
                                                    _GoalCategoryType.DRAFT
                                                "
                                            >
                                                {{
                                                    i.goal.percentToGoal
                                                        | cmpsPercent: '1.0-2'
                                                }}
                                            </span>
                                        </div>
                                        <div>
                                            {{
                                                i.daysToAchievementLeftLabel
                                                    | translate
                                            }}:
                                            <span
                                                [style.color]="
                                                    i.daysToAchievementColor
                                                "
                                            >
                                                {{ i.daysToAchievementAbs }}
                                            </span>
                                        </div>
                                    </div>
                                    <div class="right-info">
                                        <div
                                            class="right-info-chart"
                                            *ngIf="
                                                cc ===
                                                    _GoalCategoryType.ACTIVE_FOR_THIS_COMMITMENT ||
                                                cc ===
                                                    _GoalCategoryType.ACTIVE_FOR_OTHER_COMMITMENT ||
                                                cc ===
                                                    _GoalCategoryType.RECENTLY_CLOSED
                                            "
                                        >
                                            <cmps-icon
                                                svgIcon="minigoalchartup"
                                                *ngIf="
                                                    i.goal.overallImprovement >
                                                    0
                                                "
                                            ></cmps-icon>
                                            <cmps-icon
                                                svgIcon="minigoalchartdown"
                                                *ngIf="
                                                    i.goal.overallImprovement <
                                                    0
                                                "
                                            ></cmps-icon>
                                        </div>

                                        <div>
                                            <button
                                                type="button"
                                                class="btn btn-circle-blue"
                                                [disabled]="isDisabled"
                                                (click)="
                                                    _onUpdateGoalClick(
                                                        $event,
                                                        i
                                                    )
                                                "
                                                *ngIf="
                                                    !i.isOriginalWithDraft &&
                                                    (cc ===
                                                        _GoalCategoryType.DRAFT ||
                                                        cc ===
                                                            _GoalCategoryType.ACTIVE_FOR_THIS_COMMITMENT ||
                                                        cc ===
                                                            _GoalCategoryType.DISPUTED)
                                                "
                                            >
                                                <div class="dot">
                                                    <cmps-icon
                                                        svgIcon="flag"
                                                        *ngIf="
                                                            cc ===
                                                            _GoalCategoryType.DRAFT
                                                        "
                                                    ></cmps-icon>
                                                    <cmps-icon
                                                        svgIcon="buttonflagupdate"
                                                        *ngIf="
                                                            cc ===
                                                                _GoalCategoryType.ACTIVE_FOR_THIS_COMMITMENT ||
                                                            cc ===
                                                                _GoalCategoryType.DISPUTED
                                                        "
                                                    ></cmps-icon>
                                                </div>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <cmps-coaching-commitment-status
                                    [class.cmps-recent-goals-commitment--inverse-status-color]="
                                        i.goal.statusId === _GoalStatus.CLOSED
                                    "
                                    [color]="i.statusColor"
                                    [icon]="i.statusIcon"
                                    [label]="i.statusLabel | translate"
                                >
                                </cmps-coaching-commitment-status>
                            </div>
                        </ng-container>
                    </cmps-accordion-content>
                </cmps-accordion-item>
            </ng-container>
        </cmps-accordion>
    </div>
</div>

<div class="cmps-recent-goals-commitment--new-goal">
    <button
        class="cmps-button--sm"
        cmpsButton
        [disabled]="state.canManageGoals !== true || isDisabled"
        data-e2e="button-new-goal"
        (click)="_onCreateGoalClick($event)"
    >
        <cmps-icon svgIcon="flag"></cmps-icon>
        <span cmpsButtonLabel>{{
            (newFocusSelectorWithYield
                ? _i18n._11124_MANAGE_GOALS
                : _i18n._9447_CREATE_NEW_GOAL
            ) | translate
        }}</span>
    </button>
</div>
